import { Coordinates } from '../types/collectionPoints';
import { getAddress } from './googleMaps';

// Before using this function ensure that the google maps SDK has been loaded
export const geocode = async (address: string): Promise<Coordinates> => {
  const geocoder = new google.maps.Geocoder();
  const { results } = await geocoder.geocode({ address });
  const location = results[0].geometry.location;

  return {
    latitude: location.lat(),
    longitude: location.lng(),
  };
};

// Before using this function ensure that the google maps SDK has been loaded
export const reverseGeocode = async (coords: Coordinates) => {
  const geocoder = new google.maps.Geocoder();
  const { results } = await geocoder.geocode({ location: { lat: coords.latitude, lng: coords.longitude } });
  return getAddress(results[0]);
};
